import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ApiResult } from "@Services/axiosShared";

export interface CheckIfAuthenticatedState {
  /** The whole `/accounts/checkIfAuthenticated` reply, refusals included: readers branch on `data.status`. */
  data: ApiResult<"get", "/accounts/checkIfAuthenticated">;
}

const initialState: CheckIfAuthenticatedState | null = null;

const checkIfAuthenticatedSlice = createSlice({
  name: "checkIfAuthenticated",
  initialState: initialState as CheckIfAuthenticatedState | null,
  reducers: {
    setCheckIfAuthenticated: (
      _state: CheckIfAuthenticatedState | null,
      action: PayloadAction<CheckIfAuthenticatedState | null>,
    ) => action.payload,
  },
});

export const { setCheckIfAuthenticated } = checkIfAuthenticatedSlice.actions;
export default checkIfAuthenticatedSlice.reducer;
